import React from 'react'
import { BsFillGridFill } from 'react-icons/bs';
import { TfiViewListAlt } from 'react-icons/tfi';

const FileContainerHeader = ({ isGridView, setIsGridView }) => {
    return (
        <div className='flex items-center justify-between'>
            <h1 className='text-xl md:text-4xl font-bold my-3 w-fit'>Files</h1>
            <span className='text-3xl cursor-pointer' onClick={() => setIsGridView(!isGridView)}>
                {isGridView ? <BsFillGridFill /> : <TfiViewListAlt />}
            </span>
        </div>
    )
}

export default FileContainerHeader